import React from 'react';
import 'react-toastify/dist/ReactToastify.css'
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';

function News({ list }) {
    return (
        <>
            <div className='flex space-x-6 mx-auto my-auto h-sm:hidden'>
                <div className='flex h-full gap-2' style={{ width: '900px' }}>
                    {list.map((item, index) => (
                        <div
                            key={index}
                            style={{ width: '300px' }}
                            className="p-5 bg-gray-100 flex flex-col justify-between"
                        >
                            <div>
                                <img src="us_news.png" alt="logo" />
                                <div className="mt-2">
                                    <span className="text-3xl font-extrabold font-raleway">{item.title}</span>
                                </div>
                                <div className="mt-2">
                                    <span className="text-sm">{item.text}</span>
                                </div>
                            </div>
                            <Link to={"/" + item.link}>
                                <div className="mt-4 h-8 rounded-sm flex items-center justify-center" style={{ backgroundColor: '#c76f36' }}>
                                    <span className="text-base text-white" >Saiba mais</span>
                                </div>
                            </Link>
                        </div>
                    ))}
                </div>
            </div>
        </>
    );
}

export default News;